import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { useStyles } from "./styles";

export default function Step1SelectProfile({ profileId, setProfileId, setProfileName, PROFILES }) {
  const c = useStyles();
  return (
    <>
      <Typography variant="h6" gutterBottom>Selecciona el perfil de tu negocio</Typography>
      {PROFILES.map((p) => (
        <Card
          key={p.id}
          className={c.card + (profileId === p.id ? " " + c.cardSelected : "")}
          onClick={() => { setProfileId(p.id); setProfileName(p.name); }}
        >
          <CardContent>
            <Typography variant="subtitle1">{p.label}</Typography>
            <Typography variant="body2" color="textSecondary">{p.name}</Typography>
          </CardContent>
        </Card>
      ))}
    </>
  );
}
